import api from "../api/axios";

export const getPayments = async () => {
    const res = await api.get("/payments");
    return res.data;
};

export const getPayment = async (id) => {
    const res = await api.get(`/payments/${id}`);
    return res.data;
};

export const createPayment = async (data) => {
    const res = await api.post("/payments", data);
    return res.data;
};

export const updatePayment = async (id, data) => {
    const res = await api.put(`/payments/${id}`, data);
    return res.data;
};

/** Télécharge la facture PDF (route /api/payments/:id/invoice) */
export const downloadPaymentInvoice = async (paymentId) => {
    const res = await api.get(`/payments/${paymentId}/invoice`, { responseType: "blob" });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `facture-${paymentId}.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);
};

export const deletePayment = async (id) => {
    const res = await api.delete(`/payments/${id}`);
    return res.data;
};